



























































































































import { ICouponDetails } from "@/vuex/modules/coupon/interfaces";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DetailsBudgetSou extends Vue {
  @Prop(Object) readonly couponDetails!: ICouponDetails;
  @Prop(Boolean) readonly overlay!: boolean;
}
